import { Field, NumberInput, Text } from '@chakra-ui/react';
import { Control, Controller, FieldErrors } from 'react-hook-form';

interface FormNumberInputProps {
  name: string;
  label: string;
  control: Control<any>;
  errors: FieldErrors<any>;
  helperText?: string;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  placeholder?: string;
  width?: string | number;
  required?: boolean;
}

const FormNumberInput = ({
  name,
  label,
  control,
  errors,
  helperText,
  min,
  max,
  step = 1,
  disabled = false,
  placeholder,
  width = '100%',
  required,
}: FormNumberInputProps) => {
  const fieldError = errors[name];
  const isInvalid = !!fieldError;

  return (
    <Field.Root invalid={isInvalid} width={width}>
      <Field.Label>
        {label}

        {required && <Text color="red.fg">*</Text>}
      </Field.Label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <NumberInput.Root
            disabled={disabled || field.disabled}
            name={field.name}
            value={field.value}
            min={min}
            max={max}
            step={step}
            onValueChange={({ value }) => {
              field.onChange(value);
            }}
          >
            <NumberInput.Control />
            <NumberInput.Input onBlur={field.onBlur} placeholder={placeholder} />
          </NumberInput.Root>
        )}
      />
      {helperText && <Field.HelperText>{helperText}</Field.HelperText>}
      {isInvalid && fieldError?.message && (
        <Field.ErrorText>
          {typeof fieldError.message === 'string' ? fieldError.message : 'Invalid input'}
        </Field.ErrorText>
      )}
    </Field.Root>
  );
};

export default FormNumberInput;
